import { IRegion } from "@types";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";

export const columns: TableColumnsType<IRegion> = [
  {
    title: "Region",
    key: "name",
    dataIndex: "name",
    width: `calc(100% - 200px)`,
  },

  {
    title: "Actions",
    key: "action",
    width: 200,
    align: "center",
    render: (item: any) => (
      <Link
        to={`${window.location.pathname}/${item?.id}`}
        className="table__action__btn"
      >
        View
      </Link>
    ),
  },
];
